import { Card } from './Card';

const treatmentsContainerStyle = {
  display: "flex",
  flexFlow: 'row wrap',
  justifyContent: 'center',
  alignContent: "center",
  gap: "20px",
  marginBottom: "20px"
}

const treatmentOptionStyle = { 
  width: '300px',

}

export function TreatmentOption({ title, description }){
  return (
    <Card style={treatmentOptionStyle}>
      <h2>{title}</h2>
      <p>{description}</p>
    </Card>
  );
}

export function TreatmentOptions(){
  return (
    <>
      <div style={treatmentsContainerStyle}>
        <TreatmentOption
          title="Swedish Massage"
          description="
            This classic therapeutic massage releases tension, eliminates adhesions in 
            superficial muscle tissue and fascia, while promoting relaxation and mental 
            balance for our well-being.
          "
        />
        <TreatmentOption
          title="Deep Tissue Massage"
          description="
            This treatment targets deeper muscles and tendons in order to break down adhesions, 
            elongate muscle fibers, promote circulation and align posture. This is all done at a 
            slower tempo and targets patterns of chronic tension and pain. 
          "
        />
      </div>
      <div style={treatmentsContainerStyle}>
        <TreatmentOption
          title="Medical Massage"
          description="
            This treatment is more focused on a specific injury to break down adhesions and 
            tension at structures surrounding the injury site. These issues often include 
            lymphatic drainage(edema), trigger points, joint stiffness, etc.
          "
        />
        <TreatmentOption
          title="Sports Massage"
          description="
            This treatment is designed for highly athletic individuals. 
            It helps to stop and prevent muscle cramps and spasms, enhances performance, 
              prevents injury, significantly reduces recovery time and relaxes the mind. 
          "
        />
      </div>
    </>
  );
}